module.exports = require('./helpers/bundle-url').getBundleURL('aK4Nu') + "AvalancheLogo.ad53a0d0.svg";